module.exports = __webpack_public_path__ + "static/media/area-smooth-icon.06f6bb15.svg";